import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {AbstractVisbosControl} from "../../ui/forms/abstract-visbos-control";
import {PrintedSheet} from "../../../../shared/view-model/store-management/printed-sheet.type";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {appInjector} from "../../../../index";
import {ApolloQueryObservable} from "apollo-angular";
import {GenericSelectionInputComponent} from "../../ui/forms/generic-selection-input/generic-selection-input.component";
import {
  MedicineStickersService,
  PrintedSheetsResult
} from "../../../../medicine-stickers/services/medicine-stickers.service";

@Component({
  selector: 'vb-select-printed-sheet',
  templateUrl: './select-printed-sheet.component.html',
  styleUrls: ['./select-printed-sheet.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => SelectPrintedSheetComponent)}]
})
export class SelectPrintedSheetComponent extends AbstractVisbosControl<PrintedSheet, FormGroup> implements OnInit, AfterViewInit {

  Math;

  @Input()
  showStartingPoint: boolean = true;

  @Input()
  sheetTypeCuid: string;

  @Output()
  printedSheetSelected: EventEmitter<PrintedSheet> = new EventEmitter();

  @Output()
  startingPointSelected: EventEmitter<{ startRow: number, startColumn: number }> = new EventEmitter();

  @ViewChild('itemSelection')
  itemSelection: GenericSelectionInputComponent;

  selectedPrintedSheet: PrintedSheet;
  startingPoints: boolean[][];

  private printedSheetsList$: ApolloQueryObservable<PrintedSheetsResult>;
  printedSheetsList: PrintedSheet[] = [];

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private medService: MedicineStickersService) {
    super(fb, cd, sessionActions);

    this.Math = Math;
  }

  ngOnInit() {
    super.ngOnInit();

    this.printedSheetsList$ = this.medService.getPrintedSheets(null, this.sheetTypeCuid);
    this.addComponentData(this.printedSheetsList$);

    this.dataSubscriptions.push(this.printedSheetsList$.subscribe(res => {
      this.printedSheetsList = res.data.printedSheets;
    }));

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    //this.selectedPrintedSheet = this.itemSelection.selectedItem;
    this.initStartingPoints();
  }

  buildControlContent(): FormGroup {
    return SelectPrintedSheetComponent.initControl(this.fb);
  }

  public static initControl(fb?: FormBuilder) {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.group({
      sheetCuid: [null, Validators.required],
      startRow: [null],
      startColumn: [null],
    });
  }

  public setDefaultValues(item?: PrintedSheet): { [controlKey: string]: any } | any {
    return {
      sheetCuid: this.setValue(item, 'cuid'),
      startRow: 1,
      startColumn: 1
    };
  }

  onSelectedItemChanged(item: PrintedSheet) {
    this.selectedPrintedSheet = item;
    this.initStartingPoints();
    this.printedSheetSelected.emit(item);
  }

  private initStartingPoints() {
    let sp = [];
    let item = this.selectedPrintedSheet;

    if (item) {
      for (let r = 0; r < (item.rows); r++) {
        sp[r] = [];
        for (let c = 0; c < (item.columns); c++) {
          sp[r][c] = false;
        }
      }
    }

    this.startingPoints = sp;
  }

  onStartingPointClicked(row: number, column: number) {
    this.initStartingPoints();
    this.startingPoints[row][column] = true;

    let data = {
      startRow: row + 1,
      startColumn: column + 1
    };

    this.control.patchValue(data);

    this.startingPointSelected.emit(data);

  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/select-printed-sheet/select-printed-sheet.component.ts